import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { AuthGuardService } from './modules/auth/auth-guard.service';
import { LoginComponent } from './modules/auth/login/login.component';
import { ServiceRequestComponent } from './components/service-request/service-request.component';
import { ServiceRequestListComponent } from './components/service-request-list/service-request-list.component';
import { AllServiceRequestsComponent } from './components/all-service-requests/all-service-requests.component';
import { KasaComponent } from './components/kasa/kasa.component';
import { TaxSettlementComponent } from './components/tax-settlement/tax-settlement.component';
import { BankAccountComponent } from './components/bank-account/bank-account.component';
import { MailInboxComponent } from './components/mails/mail-inbox/mail-inbox.component';
import { ComposeComponent } from './components/mails/compose/compose.component';
import { InitialComponent } from './initial/initial.component';
import { AddAnonaSignalRegistrationComponent } from './modules/vik/components/modals/anona-add-signal/anona-add-signal.component';
import { AllowAnonymousGuard } from './modules/auth/AllowAnonymousGuard';
import { EPayPaymentComponent } from './components/epay/epay-payment/epay-payment.component';
import { EPayProfilePaymentComponent } from './components/epay/epay-profile/epayProfile-payment.component';
import { EPaySuccessComponent } from './components/epaysuccess/epaySuccess.component';
import { EPayFailComponent } from './components/epayfail/epayfail.component';
import { MPostPayComponent } from './components/mPost/mpost-pay.component';
import { AnonaSignalComponent } from './components/anona-signal/anona-signal.component';

export const routes: Routes = [
  // Login route (no auth required)
  { path: 'login', component: LoginComponent },

  // Protected routes
  { path: '', component: InitialComponent, canActivate: [AuthGuardService] },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuardService] },
  { path: 'service/request', component: ServiceRequestComponent, canActivate: [AuthGuardService]  },
  { path: 'fetch-data', component: FetchDataComponent, canActivate: [AuthGuardService]  },
  { path: 'service/request/list', component: ServiceRequestListComponent, canActivate: [AuthGuardService] },
  { path: 'service/request/all', component: AllServiceRequestsComponent, canActivate: [AuthGuardService] },
  { path: 'kasa', component: KasaComponent, canActivate: [AuthGuardService] },
  { path: 'bank/accounts', component: BankAccountComponent, canActivate: [AuthGuardService] },
  { path: 'tax/settlement', component: TaxSettlementComponent, canActivate: [AuthGuardService] },
  { path: 'mail/inbox', component: MailInboxComponent, canActivate: [AuthGuardService] },
  { path: 'mail/compose', component: ComposeComponent, canActivate: [AuthGuardService] },
  { path: 'epay', component: EPayPaymentComponent, canActivate: [AuthGuardService] },
  { path: 'epay/profile', component: EPayProfilePaymentComponent, canActivate: [AuthGuardService] },
  { path: 'success', component: EPaySuccessComponent, canActivate: [AuthGuardService] },
  { path: 'cancel', component: EPayFailComponent, canActivate: [AuthGuardService] },
  { path: 'mpost', component: MPostPayComponent, canActivate: [AuthGuardService] },

  // Public routes (no auth required)
  { path: 'public', component: AddAnonaSignalRegistrationComponent, canActivate: [AllowAnonymousGuard] },
  { path: 'anona', component: AnonaSignalComponent, canActivate: [AllowAnonymousGuard] },

  // Lazy-loaded modules
  {
    path: 'issues',
    loadChildren: () => import('./modules/issue-Manager/issue-manager.module').then((m) => m.IssueManagerModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule)
  },
  {
    path: 'vik',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./modules/vik/vik.module').then((m) => m.VikModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
